// 个例监控类型
import { trpc as IssueListType } from '@tencent/tpro_rmonitor_web_server_issue_list';
import { trpc as IssueStatistics } from '@tencent/tpro_rmonitor_web_server_issue_statistics';
import { FilterEntry } from '@/presentation/components/form/types';
import { Zone } from '@/proto/field';
import { ExceptionType } from '@/proto/metric';
import { WithTypeCast } from '@raft/utils';

export type IGetTopIssuesReq = WithTypeCast<IssueListType.rmonitor.web_server.IGetTopIssuesReq>;
export type IGetTopIssuesRsp = WithTypeCast<IssueListType.rmonitor.web_server.IGetTopIssuesRsp>;
export type ITopIssueInfo = WithTypeCast<IssueListType.rmonitor.web_server.ITopIssueInfo>;
export type ICondition = WithTypeCast<IssueListType.rmonitor.web_server.ICondition>;
// export type IssueType = WithTypeCast<IssueListType.rmonitor.web_server.IssueType>;
export type IssueType = any;
// TODO 需要处理多个IssueType类型不匹配问题
export const { IssueType } = IssueListType.rmonitor.web_server as any;
export const { IssueType: WebServerIssueType } = IssueListType.rmonitor.web_server;
export type TimeType = WithTypeCast<IssueListType.rmonitor.web_server.TimeType>;
export const { TimeType } = IssueListType.rmonitor.web_server;
// 时间窗口类型（兼容旧代码）
export type IssueTimeType = WithTypeCast<TimeType>;
export const IssueTimeType = TimeType;

export type IssueMetricType = WithTypeCast<IssueStatistics.rmonitor.web_server.IssueMetricType>;
export const { IssueMetricType } = IssueStatistics.rmonitor.web_server;

const exceptionMap: {[key: string]: ExceptionType} = {
  [IssueType.ISSUE_TYPE_CRASH]: ExceptionType.Crash,
  [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: ExceptionType.ElectronCrash,
  [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: ExceptionType.ElectronJsPromiseError,
  [97]: ExceptionType.WebJsPromiseError,
  [IssueType.ISSUE_TYPE_ERROR]: ExceptionType.Error,
  [IssueType.ISSUE_TYPE_ANR_BUGLY]: ExceptionType.Anr,
  [IssueType.ISSUE_TYPE_FOOM_BUGLY]: ExceptionType.Foom,
};

const zoneMap: {[key: string]: Zone} = {
  [IssueType.ISSUE_TYPE_CRASH]: Zone.Crash,
  [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: Zone.ElectronCrash,
  [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: Zone.ElectronJsPromiseError,
  [97]: Zone.WebJsPromiseError,
  [IssueType.ISSUE_TYPE_ERROR]: Zone.Error,
  [IssueType.ISSUE_TYPE_ANR_BUGLY]: Zone.AndroidANR,
  [IssueType.ISSUE_TYPE_FOOM_BUGLY]: Zone.AndroidANR,
};

const fieldZoneMap: {[key: string]: Zone} = {
  [IssueType.ISSUE_TYPE_CRASH]: Zone.Crash,
  [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: Zone.ElectronCrash,
  [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: Zone.ElectronJsPromiseError,
  [97]: Zone.WebJsPromiseError,
  [IssueType.ISSUE_TYPE_ERROR]: Zone.Error,
  [IssueType.ISSUE_TYPE_ANR_BUGLY]: Zone.AndroidANR,
  [IssueType.ISSUE_TYPE_FOOM_BUGLY]: Zone.AndroidFoom,
};

export const getIssueType = (exceptionType: ExceptionType) => Object.keys(exceptionMap)
  .find(key => exceptionMap[key] === exceptionType);

export const getExceptionType = (issueType: IssueType) => exceptionMap[issueType];

export const getZone = (issueType: IssueType) => zoneMap[issueType];

export const getFieldZone = (issueType: IssueType) => fieldZoneMap[issueType];

export const getFilterEntryDetail = (issueType: IssueType) => {
  const map: {[key: string]: FilterEntry} = {
    [IssueType.ISSUE_TYPE_CRASH]: FilterEntry.CrashDetail,
    [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: FilterEntry.CrashDetail,
    [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: FilterEntry.ErrorDetail,
    [97]: FilterEntry.ErrorDetail,
    [IssueType.ISSUE_TYPE_ERROR]: FilterEntry.ErrorDetail,
    [IssueType.ISSUE_TYPE_ANR_BUGLY]: FilterEntry.ANRDetail,
    [IssueType.ISSUE_TYPE_FOOM_BUGLY]: FilterEntry.FoomDetail,
  };
  return map[issueType];
};

export const getFilterEntryAnalysis = (issueType: IssueType) => {
  const map: {[key: string]: FilterEntry} = {
    [IssueType.ISSUE_TYPE_CRASH]: FilterEntry.CrashAnalysis,
    [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: FilterEntry.CrashAnalysis,
    [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: FilterEntry.ErrorAnalysis,
    [97]: FilterEntry.ErrorAnalysis,
    [IssueType.ISSUE_TYPE_ERROR]: FilterEntry.ErrorAnalysis,
    [IssueType.ISSUE_TYPE_ANR_BUGLY]: FilterEntry.ANRAnalysis,
    [IssueType.ISSUE_TYPE_FOOM_BUGLY]: FilterEntry.FoomAnalysis,
  };
  return map[issueType];
};

export const getFilterEntryList = (issueType: IssueType) => {
  const map: {[key: string]: FilterEntry} = {
    [IssueType.ISSUE_TYPE_CRASH]: FilterEntry.CrashList,
    [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: FilterEntry.CrashList,
    [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: FilterEntry.ErrorList,
    [97]: FilterEntry.ErrorList,
    [IssueType.ISSUE_TYPE_ERROR]: FilterEntry.ErrorList,
    [IssueType.ISSUE_TYPE_ANR_BUGLY]: FilterEntry.ANRList,
    [IssueType.ISSUE_TYPE_FOOM_BUGLY]: FilterEntry.FoomList,
  };
  return map[issueType];
};

export const getFilterEntryTable = (issueType: IssueType) => {
  const map: {[key: string]: FilterEntry} = {
    [IssueType.ISSUE_TYPE_CRASH]: FilterEntry.CrashTable,
    [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: FilterEntry.CrashTable,
    [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: FilterEntry.ErrorTable,
    [97]: FilterEntry.ErrorTable,
    [IssueType.ISSUE_TYPE_ERROR]: FilterEntry.ErrorTable,
    [IssueType.ISSUE_TYPE_ANR_BUGLY]: FilterEntry.ANRTable,
    [IssueType.ISSUE_TYPE_FOOM_BUGLY]: FilterEntry.FoomTable,
  };
  return map[issueType];
};

export const getFilterEntrySplit = (issueType: IssueType) => {
  const map: {[key: string]: FilterEntry} = {
    [IssueType.ISSUE_TYPE_CRASH]: FilterEntry.CrashSplit,
    [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: FilterEntry.CrashSplit,
    [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: FilterEntry.ErrorSplit,
    [97]: FilterEntry.ErrorSplit,
    [IssueType.ISSUE_TYPE_ERROR]: FilterEntry.ErrorSplit,
    [IssueType.ISSUE_TYPE_ANR_BUGLY]: FilterEntry.ANRSplit,
    [IssueType.ISSUE_TYPE_FOOM_BUGLY]: FilterEntry.FoomSplit,
  };
  return map[issueType];
};

export const getFilterEntryLogFrequency = (issueType: IssueType) => {
  const map: {[key: string]: FilterEntry} = {
    [IssueType.ISSUE_TYPE_CRASH]: FilterEntry.CrashLogFrequency,
    [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: FilterEntry.CrashLogFrequency,
    [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: FilterEntry.ErrorLogFrequency,
    [97]: FilterEntry.ErrorLogFrequency,
    [IssueType.ISSUE_TYPE_ERROR]: FilterEntry.ErrorLogFrequency,
    [IssueType.ISSUE_TYPE_ANR_BUGLY]: FilterEntry.ANRLogFrequency,
    [IssueType.ISSUE_TYPE_FOOM_BUGLY]: FilterEntry.FoomLogFrequency,
  };
  return map[issueType];
};

export const getSplitIssueType = (issueType: IssueType) => {
  const map: {[key: string]: IssueType} = {
    [IssueType.ISSUE_TYPE_CRASH]: IssueType.ISSUE_TYPE_CRASH_FOR_SUB_ISSUE,
    [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: IssueType.ISSUE_TYPE_CRASH_FOR_SUB_ISSUE,
    [IssueType.ISSUE_TYPE_ERROR]: IssueType.ISSUE_TYPE_ERROR_FOR_SUB_ISSUE,
    [IssueType.ISSUE_TYPE_ANR_BUGLY]: IssueType.ISSUE_TYPE_ANR_FOR_SUB_ISSUE,
  };
  return map[issueType];
};


export const getTypeByZone = (zone: Zone) => {
  if ([Zone.Crash, Zone.AndroidANR, Zone.Error, Zone.AndroidFoom].includes(zone)) {
    return Zone.Exception;
  }

  return zone;
};

// 质量
const zoneByMap: Record<number, Zone> = {
  [IssueType.ISSUE_TYPE_CRASH]: Zone.Crash,
  [IssueType.ISSUE_TYPE_ELECTRON_CRASH]: Zone.Crash,
  [IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR]: Zone.ElectronJsPromiseError,
  [97]: Zone.WebJsPromiseError,
  [IssueType.ISSUE_TYPE_ANR_BUGLY]: Zone.AndroidANR,
  [IssueType.ISSUE_TYPE_ERROR]: Zone.Error,
  [IssueType.ISSUE_TYPE_FOOM_BUGLY]: Zone.AndroidFoom,
};

export const getZoneByIssueType = (issueType: IssueType) => zoneByMap[issueType];
